import React from 'react';
import {
  Button,
  Select,
  MenuItem,
  Typography,
  Tooltip,
} from '@material-ui/core';
import styled from 'styled-components';

const Chevron = styled.i`
  cursor: pointer;
  color: ${(props) => (props.disabled ? 'lightgray' : 'dimgray')};
`;

export default function CustomPagination({
  page,
  setPage,
  rowsPerPage,
  setRowsPerPage,
  hasNextPage,
  disabled = false, // disabled because of unsaved changes
}) {
  const handleBack = () => {
    if (page > 1) setPage(page - 1);
  };

  const handleForward = () => {
    if (hasNextPage) setPage(page + 1);
  };

  const handleRowsChange = (event) => {
    setRowsPerPage(event.target.value);
    setPage(1);
  };

  /**
   * Get disable reason for a control
   * @param {string} type - "back" | "forward" | "select"
   */
  const getDisabledReason = (type) => {
    if (disabled) return 'unsaved'; // global lock
    if (type === 'back' && page === 1) return 'firstPage';
    if (type === 'forward' && !hasNextPage) return 'noNextPage';
    return null;
  };

  const tooltipMessages = {
    unsaved: 'You have unsaved changes',
    firstPage: 'You are already on the first page',
    noNextPage: 'No more pages',
  };

  const withTooltip = (reason, child) => {
    if (!reason) return child;
    return (
      <Tooltip title={tooltipMessages[reason]} placement='top'>
        <span>{child}</span>
      </Tooltip>
    );
  };

  return (
    <div
      style={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'flex-end',
        gap: '50px',
        padding: '10px 0',
        width: '100%',
      }}
    >
      {/* Rows per page */}
      <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
        <Typography>Results per page:</Typography>
        {withTooltip(
          getDisabledReason('select'),
          <Select
            small
            pagination
            isSearchable={false}
            value={rowsPerPage}
            onChange={handleRowsChange}
            disabled={!!getDisabledReason('select')}
            style={{
              border: '1px solid #ccc',
              borderRadius: 4,
              padding: '4px 8px',
              minWidth: '80px',
            }}
          >
            {[10, 25, 50].map((size) => (
              <MenuItem key={size} value={size}>
                {size}
              </MenuItem>
            ))}
          </Select>
        )}
      </div>

      {/* Pagination controls */}
      <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
        {withTooltip(
          getDisabledReason('back'),
          <Button onClick={handleBack} disabled={!!getDisabledReason('back')}>
            <span style={{ display: 'flex', alignItems: 'center', gap: '4px' }}>
              <Chevron className='fa fa-chevron-left' disabled />
              Back
            </span>
          </Button>
        )}

        <span>{page}</span>

        {withTooltip(
          getDisabledReason('forward'),
          <Button
            onClick={handleForward}
            disabled={!!getDisabledReason('forward')}
          >
            <span style={{ display: 'flex', alignItems: 'center', gap: '4px' }}>
              Forward
              <Chevron className='fa fa-chevron-right' disabled />
            </span>
          </Button>
        )}
      </div>
    </div>
  );
}
